import { render } from "./DataInventory.vue?vue&type=template&id=358e6246"
import script from "./DataInventory.vue?vue&type=script&lang=js"
export * from "./DataInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__